import "@ant-design/v5-patch-for-react-19";
import "antd/dist/reset.css";
import "./styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { BrowserRouter } from "react-router-dom";
import { AgentApp } from "./shell";
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#2563eb",
          colorInfo: "#2563eb",
          colorSuccess: "#16a085",
          colorWarning: "#e3a532",
          colorError: "#de5968",
          colorText: "#1c2b43",
          colorTextSecondary: "#78869b",
          colorBorder: "#e5eaf2",
          colorBgLayout: "#f4f6fa",
          borderRadius: 10,
          fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
          controlHeight: 38,
        },
        components: {
          Table: {
            headerBg: "#f7f9fc",
            headerColor: "#697a91",
            rowHoverBg: "#f8fbff",
            cellPaddingBlock: 18,
          },
          Card: { paddingLG: 24 },
          Menu: { itemHeight: 46 },
        },
      }}
    >
      <App>
        <BrowserRouter>
          <AgentApp />
        </BrowserRouter>
      </App>
    </ConfigProvider>
  </React.StrictMode>,
);
